import React, { useState } from 'react';

const PDFViewer = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  
  // Your PDF file path from assets folder (use %20 for spaces)
  const pdfPath = '/assets/AGM 2024_25 new.pdf';
  const pdfName = 'AGM 2025.pdf';

  // Inline styles as backup for colors
  const buttonStyles = {
    viewButton: {
      background: 'linear-gradient(135deg, #3b82f6, #4f46e5)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '16px 32px',
      cursor: 'pointer',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s'
    },
    downloadButton: {
      background: 'linear-gradient(135deg, #10b981, #059669)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '16px 32px',
      cursor: 'pointer',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s'
    }
  };

  const handleDownload = () => {
    // Try direct download first
    try {
      const link = document.createElement('a');
      link.href = pdfPath;
      link.download = pdfName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback: open in new window
      window.open(pdfPath, '_blank');
    }
  };

  const handleView = () => {
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  const testFileAccess = async () => {
    try {
      const response = await fetch(pdfPath);
      if (response.ok) {
        alert('✅ PDF file found! You can now view and download it.');
      } else {
        alert(`❌ PDF file not found (Status: ${response.status}). Please check:\n1. File is in public/assets/ folder\n2. Filename matches exactly\n3. Try renaming file without spaces`);
      }
    } catch (error) {
      alert(`❌ Error accessing PDF: ${error.message}`);
    }
  };

  const openInNewTab = () => {
    window.open(pdfPath, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-2xl p-8 border border-gray-100">
          <div className="flex items-center justify-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mr-6 shadow-lg">
              <span className="text-4xl">📄</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">PDF Document</h1>
              <p className="text-gray-600 text-lg">{pdfName}</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleView}
              style={buttonStyles.viewButton}
              className="flex items-center justify-center px-8 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 font-medium shadow-lg transform hover:scale-105"
            >
              <span className="mr-2 text-xl">👁️</span>
              View PDF
            </button>&nbsp;
            
            <button
              onClick={handleDownload}
              style={buttonStyles.downloadButton}
              className="flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 font-medium shadow-lg transform hover:scale-105"
            >
              <span className="mr-2 text-xl">⬇️</span>
              Download PDF
            </button>
          </div>

          {/* PDF Preview Card */}
          <div className="mt-8 p-6 border-2 border-dashed border-indigo-300 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50">
            <div className="text-center">
              {/* <div className="w-16 h-16 bg-gradient-to-br from-indigo-400 to-purple-500 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <span className="text-3xl">📄</span>
              </div> */}
              {/* <p className="text-indigo-700 mb-4 font-semibold text-lg">PDF Preview</p> */}
              {/* <div className="bg-white bg-opacity-60 h-40 rounded-xl flex items-center justify-center border border-indigo-200 shadow-inner">
                <span className="text-indigo-600 font-medium">Click "View PDF" to open the document</span>
              </div> */}
            </div>
          </div>
        </div>

        {/* Full Screen PDF Viewer Modal */}
        {isViewerOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-90 z-50">
            <div className="bg-white w-screen h-screen flex flex-col">
              <div className="flex items-center justify-between p-3 border-b bg-gradient-to-r from-blue-600 to-purple-600">
                {/* <h2 className="text-xl font-bold text-white">📄 {pdfName}</h2> */}
                <div className="flex gap-3">
                  {/* <button
                    onClick={handleDownload}
                    className="flex items-center px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all duration-200 shadow-lg"
                  >
                    <span className="mr-2">⬇️</span>
                    Download
                  </button> */}
                  <button
                    onClick={closeViewer}
                    className="flex items-center justify-center w-10 h-10 bg-red-500 text-red rounded-lg hover:bg-red-600 transition-all duration-200 shadow-lg"
                  >
                    <span className="text-lg">Close PDF</span>
                  </button>
                </div>
              </div>
              <div className="flex-1" style={{ height: 'calc(100vh - 60px)' }}>
                <iframe
                  src={`${pdfPath}#zoom=page-width&toolbar=1&view=FitV`}
                  className="w-full h-full border-0"
                  title="PDF Viewer"
                  style={{ 
                    width: '100%',
                    height: '100%',
                    minHeight: '100%'
                  }}
                  onError={() => {
                    alert('Error loading PDF. Trying to download instead...');
                    handleDownload();
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFViewer;